import { IconButton, Link, Tooltip } from '@chakra-ui/react';
import React from 'react';
import { useTokens } from '../../../../context/TokenProvider';
import { generateEndpoint, INSPECTIONS_EXPORT, } from '../../../../services/http/endpoints';
import { localise, templateReplace } from '../../../../services/lang/lang';
import { useInspectionListingContext } from './InspectionListingProvider';
import DownloadIcon from '../../../icons/DownloadIcon/DownloadIcon';
const InspectionListingDownloadButton = ({ statuses }) => {
    const buttonStyle = { w: '56px', h: '48px' };
    const tokens = useTokens();
    const { status, scope } = useInspectionListingContext();
    const scopeText = scope.split('-')[0];
    const statusText = statuses.find((s) => s.id === status)?.name ?? '';
    const downloadText = templateReplace(localise('DOWNLOAD_INSPECTIONS'), {
        scope: scopeText,
        status: statusText.toLocaleLowerCase(),
    });
    const link = generateEndpoint(INSPECTIONS_EXPORT, {
        scope,
        statusId: status.toString(),
    });
    return (React.createElement(Tooltip, { "aria-label": downloadText, role: "tooltip", placement: "bottom", hasArrow: true, sx: {
            whiteSpace: 'nowrap',
            maxWidth: 'unset',
        }, label: downloadText },
        React.createElement(Link, { "data-testid": "inspection_listing_download_link", href: link },
            React.createElement(IconButton, { "aria-label": downloadText, sx: buttonStyle, onClick: (e) => e.stopPropagation(), variant: "white-grey", "data-testid": "inspection_listing_download_button", colorScheme: tokens.Layer01, icon: React.createElement(DownloadIcon, null) }))));
};
export default InspectionListingDownloadButton;
